<template>
	<div class="header">
		<!-- 折叠按钮 -->
		<div class="collapse-btn" @click="collapseChage">
			<i v-if="!collapse" class="el-icon-s-fold"></i>
			<i v-else class="el-icon-s-unfold"></i>
		</div>
		<!-- <div class="logo">后台管理系统</div> -->
		<div class="header-right">
			<div class="header-user-con">
        <!-- 数据中台 -->
        <div class="" style="margin-right: 5px;font-size: 1.5rem;cursor: pointer;" @click="toData">
        	<el-tooltip effect="dark" :content="`数据中台`" placement="bottom">
        		<i class="el-icon-data-line"></i>
        	</el-tooltip>
        </div>
				<!-- 全屏显示 -->
				<div class="btn-fullscreen" @click="handleFullScreen">
					<el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
						<i class="el-icon-rank"></i>
					</el-tooltip>
				</div>
				<!-- 消息中心 -->
				<div class="btn-bell">
					<el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">
						<router-link to="/tabs">
							<i class="el-icon-bell"></i>
						</router-link>
					</el-tooltip>
					<span class="btn-bell-badge" v-if="message"></span>
				</div>
				<!-- 用户头像 -->
				<div class="user-avator">
					<img src="../../assets/imgs/data_head1.png" />
				</div>
				<!-- 用户名下拉菜单 -->
				<el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
                        {{name}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
					<el-dropdown-menu slot="dropdown">
						<a href="" target="_blank">
							<el-dropdown-item>个人资料</el-dropdown-item>
						</a>
						<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '../common/bus';
	export default {
		data() {
			return {
				collapse: false,
				fullscreen: false,
				name: 'Administrator',
				message: 2
			};
		},
    activated() {
      let username = window.sessionStorage.getItem('ms_username');
      this.name = username ? username : this.name;
    },
    created() {
      let username = window.sessionStorage.getItem('ms_username');
      this.name = username ? username : this.name;
    },
		computed: {
			// username() {
			// 	let username = window.sessionStorage.getItem('ms_username');
			// 	return username ? username : this.name;
			// }
		},
		methods: {
			// 用户名下拉菜单选择事件
			handleCommand(command) {
				if(command == 'loginout') {
					window.sessionStorage.removeItem('ms_username');
          window.sessionStorage.removeItem("user_info")
					this.$router.push('/login');
				}
			},
      toData() {
        window.location.href = 'https://ctjdwx.cdqingyang.gov.cn:8081/login.html'
      },
			// 侧边栏折叠
			collapseChage() {
				this.collapse = !this.collapse;
				bus.$emit('collapse', this.collapse);
			},
			// 全屏事件
			handleFullScreen() {
				let element = document.documentElement;
				if(this.fullscreen) {
					if(document.exitFullscreen) {
						document.exitFullscreen();
					} else if(document.webkitCancelFullScreen) {
						document.webkitCancelFullScreen();
					} else if(document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if(document.msExitFullscreen) {
						document.msExitFullscreen();
					}
				} else {
					if(element.requestFullscreen) {
						element.requestFullscreen();
					} else if(element.webkitRequestFullScreen) {
						element.webkitRequestFullScreen();
					} else if(element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if(element.msRequestFullscreen) {
						// IE11
						element.msRequestFullscreen();
					}
				}
				this.fullscreen = !this.fullscreen;
			}
		},
		mounted() {
			if(document.body.clientWidth < 1500) {
				this.collapseChage();
			}
		}
	}
</script>

<style scoped>
	.header {
		position: relative;
		box-sizing: border-box;
		width: 100%;
		height: 3.3333vw;
		font-size: 22px;
		color: #333333;
	}

	.collapse-btn {
		position: absolute;
		top: 1.1458vw;
		float: left;
		padding: 0 21px;
		cursor: pointer;
		font-size: .8854vw;
		/* line-height: 2.6042vw; */
	}

	.header .logo {
		float: left;
		width: 250px;
		line-height: 2.6042vw;
	}

	.header-right {
		float: right;
		padding-right: 50px;
	}

	.header-user-con {
		display: flex;
		height: 3.3333vw;
		align-items: center;
	}

	.btn-fullscreen {
		transform: rotate(45deg);
		margin-right: 5px;
		font-size: 24px;
	}

	.btn-bell,
	.btn-fullscreen {
		position: relative;
		width: 1.5625vw;
		height: 1.5625vw;
    line-height: 1.5625vw;
		text-align: center;
		border-radius: 15px;
		cursor: pointer;
	}

	.btn-bell-badge {
		position: absolute;
		right: 0;
		top: -2px;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background: #f56c6c;
		color: #333333;
	}

	.btn-bell .el-icon-bell {
		color: #333333;
	}

	.user-name {
		margin-left: 10px;
	}

	.user-avator {
		margin-left: 20px;
	}

	.user-avator img {
		display: block;
		width: 1.5625vw;
		height: 1.5625vw;
		border-radius: 50%;
	}

	.el-dropdown-link {
		color: #333333;
		cursor: pointer;
	}

	.el-dropdown-menu__item {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue